const keyMirror = require('fbjs/lib/keyMirror');

/**
 * Application action constants
 *
 * @type {{ActionTypes: {user: (*|exports), venues: (*|exports), dashboard: (*|exports), menuUrls: (*|exports)}}}
 */
module.exports = {
    ActionTypes: {
        users: keyMirror({
            RECEIVED_INSTRUCTOR_LIST: null,
            UPDATED_USER: null,
            FAILED_REQUEST: null, // @todo should failures be a universal event?
            DEACTIVATED_USER: null,
            NEW_SORT_ORDER: null,
            REVERIFIED_SUBSCRIPTION: null
        }),
        menuUrls: keyMirror({
            RECEIVED_MENUURLS_LIST: null,
            UPDATED_MENUURLS: null
        }),

        subscriptions: keyMirror({
            RECEIVED_SUBSCRIPTIONS_LIST: null,
            UPDATED_SUBSCRIPTION: null,
            DEACTIVATED_SUBSCRIPTION: null,
            ADDED_SUBSCRIPTION: null
        }),

        genres: keyMirror({
            RECEIVED_ALL_GENRES: null
        }),

        strings: keyMirror({
            RECEIVED_LEGAL_DISCLAIMER: null
        }),

        casts: keyMirror({
            STORE_CAST: null,
            CLEAR_STORED_CAST: null
        }),

        albums: keyMirror({
            RECEIVED_ALL_ALBUMS: null
        }),

        artists: keyMirror({
            RECEIVED_ALL_ARTISTS: null
        }),

        messages: keyMirror({
            CLEAR_STORED_MESSAGE: null
        }),
    }
};
